import React from 'react';
import {IDrawerContent} from "../../../drawer/drawer.service.interface";
import {IServiceFactoryExtended} from "../../../service-factory-extended.interface";
import {
    AdvancedGamesFilterComponent
} from "../../../../components/filters/advanced-filtering/advanced-games-filter.component";
import {AdvancedStrategyFiltersEditor} from "./advanced-strategy-filters-editor";

export class AdvancedGamesFilterDrawerRenderer implements IDrawerContent {

    constructor(private readonly services: IServiceFactoryExtended,
                private readonly filtersEditor: AdvancedStrategyFiltersEditor) {
        this.id = this.services.tools.getGuid();
    }

    readonly id: string;
    readonly isMinimized: boolean = false;
    readonly minOverlayZIndex: number | null = null;
    supportsCloseIntent: boolean = false;
    readonly title: string = '';

    onClose(): void {
    }

    onOverlayClicked(): void {
    }

    render(): React.ReactNode {
        return (
            <AdvancedGamesFilterComponent filtersEditor={this.filtersEditor}/>
        );
    }
}